import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController,
  ToastController,
  ModalController
} from "ionic-angular";
import { DatabaseProvider } from "../../providers/database/database";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/mergeMap";
import { AuthProvider } from "../../providers/auth/auth";
import * as _ from "lodash";
import * as moment from "moment";
import { SurveyPage } from "../survey/survey";
import { AngularFirestore } from "angularfire2/firestore";

@IonicPage()
@Component({
  selector: "page-admin-studies",
  templateUrl: "admin-studies.html"
})
export class AdminStudiesPage {
  public studyList: Observable<any[]>;
  public doctorList: Observable<any[]>;
  public medList: Observable<any[]>;
  clinic_name: string;
  clinic_id: string;
  user_role: boolean;
  filter: string;
  public clinic: any;
  rowSelection: any;

  public studystatus = [{id: 'enrolled', name: 'Enrolled'},{id: 'notenrolled', name: 'Not Enrolled'},{id: 'cancelled', name: 'Cancelled'}];
  status: string = "All";

  gridApi: any;
  columnDefs: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
    private afs: AngularFirestore
  ) {
    this.rowSelection = "single";
    this.auth.getCurrentUser().then(user => {
      this.user_role = user.roles;
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;

      this.database.getClinic(this.clinic_id).valueChanges().subscribe((clinic) => {
        if(clinic)  {
          this.clinic = clinic;
        }
      });

      this.columnDefs = [
        { headerName: "Clinic", field: "clinic_name" },
        {
          headerName: "Patient",
          valueGetter: function getStatus(params) {
            if(user.roles.clinic_tester) {
              return "-------------";
            }
            else if(user.roles.opteva_admin) {
              return params.data.patient.full_name;
            }
            else {
              return params.data.patient.full_name;
            }
          }
        },
        { headerName: "Doctor", field: "doctor.full_name" },
        {
          headerName: "Study",
          valueGetter: function getStudy(params) {
            return _.map(params.data.study, "name").join(", ");
          }
        },
        {
          headerName: "Date",
          valueGetter: function getMeds(params) {
            return moment(params.data.createdAt.toDate()).format("MMM DD YYYY h:mm A") // 27 January 10:30 am
          }
        },
        { headerName: "Speed", field: "speedscore" },
        {
          headerName: "Status",
          valueGetter: function getStatus(params) {
            if(params.data._status === 'enrolled') {
              return "Enrolled";
            }
            else if(params.data._status === 'notenrolled') {
              return "Not Enrolled";
            }
            else if(params.data._status === 'cancelled') {
              return "Cancelled";
            }
            else {
              return "---";
            }
          }
        },
        {
          headerName: "Consent",
          field: "consent_agreement",
          cellRenderer: function(params) {
            if(params.value)  {
              return '<a target="_blank" href="' + params.value + '">Consent</a>';
            }
          }
        }
      ];

      this.getStudies();
    });
  }

  ionViewDidLoad() {}

  click(params) {
    console.log('Row clicked: ', params);
  }

  public formatDate(date) {
    let myMoment: moment.Moment
    if (date.seconds) {
      myMoment = moment.unix(date.seconds);
    } else {
      myMoment = moment(date);
    }
    return myMoment.format("YYYY MMM DD");
  }

  CompleteStudy(study)  {

    let studydata = {
      clinic: this.clinic,
      patient: study.patient,
      doctor: study.doctor,
      medication: study.medication,
      study: study.study,
      renewal: false
    };

    let studyModal = this.modalCtrl.create(SurveyPage, studydata, {cssClass: 'select-modal', enableBackdropDismiss: false });
    studyModal.onDidDismiss(data => {
      console.log(data)
      if(data['completed'])  {
        this.database.completeStudy(study.id, this.clinic_id, data.patient_id, data)
      }      
    });
    studyModal.present();
  }

  public getStudies() {
    let status: string = null;
    status = this.status;
    this.studyList = this.afs.collection(`studyresults`, ref => {
      let query : firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
      if(status === 'enrolled' || status === 'notenrolled' || status === 'cancelled') query = query.where('_status', '==', status);
      return query.orderBy("createdAt", "desc");
    })
    .snapshotChanges()
    .map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as any;
        data.id = a.payload.doc.id;
        data["doctor"]["full_name"] =
        data["doctor"]["first_name"] + " " + data["doctor"]["last_name"];
        return data;
      });
    });
  }

 getStudyList()  {
    this.studyList = this.database
        .getStudiesByClinic(this.clinic_id)
        .snapshotChanges()
        .map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            data.id = a.payload.doc.id;
            return data;
          });
        });
  }

  filterChanged(ev) {
    this.getStudyList();
  }

  segmentChanged(ev)  {
    this.status = ev.value;
    this.getStudies();
  }

  onGridReady(params) {
    this.gridApi = params.api;

  }

  onBtExport() {
    this.gridApi.exportDataAsCsv();
  }

  onCellClicked(ev) {
    console.log(ev)
    const study = ev.data;
    this.updateStatus(study);
  }

  updateStatus(study) {
      const alert = this.alertCtrl.create({

      title: "Update Status",
        inputs: [
            {
              type: 'radio',
              label: 'Enrolled',
              value: 'enrolled',
              checked: study._status === 'enrolled'
            },
            {
              type: 'radio',
              label: 'Not Enrolled',
              value: 'notenrolled',
              checked: study._status === 'notenrolled'
            },
            {
              type: 'radio',
              label: 'Cancelled',
              value: 'cancelled',
              checked: study._status === 'cancelled'
            }
        ],
        buttons: [
          {
            text: "Update",
            role: "submit",
            handler: data => {
              console.log('Update Study: ', study.clinic_id, study.patient_id, study.id, data);
              this.database.updateStudyStatus(study.clinic_id, study.patient_id, study.id, data);
            }
          },
          {
            text: "Cancel",
            role: "cancel",
            handler: data => console.log("Cancel clicked")
          }
        ]
      });
      alert.present();


    }
  }


// WEBPACK FOOTER //
// ./src/pages/admin-studies/admin-studies.ts